import Flex from '@Components/Bases/Flex';
import { FormDatePicker, FormInput } from '@Components/Form';
import { disabledDatePickerTypingStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput/FormatNumberInput';
import { Box, InputLabel, Typography } from '@mui/material';

type OtherGreenhouseGasBaseYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const OtherGreenhouseGasBaseYear = ({
  isCompletedTh,
  isCompletedEn,
}: OtherGreenhouseGasBaseYearProps) => {
  return (
    <>
      <Typography fontWeight="bold">
        เป้าหมายลดการปล่อยก๊าซเรือนกระจกเทียบกับปีฐาน
      </Typography>
      <Typography fontWeight="bold" mt={2} sx={{ textDecoration: 'underline' }}>
        ปีฐาน (ถ้ามี)
      </Typography>
      <Flex gap={2} mb={2} alignItems="center" justifyContent="end">
        <InputLabel sx={{ textAlign: 'end', minWidth: '350px' }}>
          ปีฐาน
        </InputLabel>
        <FormDatePicker
          disabled={isCompletedTh || isCompletedEn}
          sx={{ width: '100%', ...disabledDatePickerTypingStyles }}
          views={['year']}
          format="BBBB"
          name="baseYear.year"
          placeholder="เลือกปีฐาน"
          slotProps={{
            field: { clearable: true },
            toolbar: { hidden: false },
          }}
          localeText={{ toolbarTitle: 'เลือก ปี' }}
        />
      </Flex>
      <Flex gap={2} alignItems="center" justifyContent="end">
        <Box>
          <InputLabel sx={{ textAlign: 'end', minWidth: '350px' }}>
            ปริมาณการปล่อยก๊าซเรือนกระจก ณ ปีฐาน
          </InputLabel>
          <InputLabel sx={{ textAlign: 'end', minWidth: '350px' }}>
            (ตันคาร์บอนไดออกไซด์เทียบเท่า, tCO<sub>2</sub>e)
          </InputLabel>
        </Box>
        <FormInput
          disabled={isCompletedTh || isCompletedEn}
          name="baseYear.gasEmissionQuantity"
          placeholder="โปรดระบุจำนวน"
          sx={{
            width: '100%',
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
        />
      </Flex>
    </>
  );
};

export default OtherGreenhouseGasBaseYear;
